import type { RouteRecordRaw } from 'vue-router'
import { ConfigShareRouteName } from '@/service/config_share/config_share_routes'

const EmptyRoute = {
  render: () => null,
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: ConfigShareRouteName.workspace,
    component: EmptyRoute,
  },
  {
    path: '/config-share',
    name: ConfigShareRouteName.home,
    component: () => import('@/components/config_share/config_share_home.vue'),
    meta: { layout: 'config-share' },
  },
  {
    path: '/config-share/publish',
    name: ConfigShareRouteName.publish,
    component: () => import('@/components/config_share/config_share_publish.vue'),
    meta: { layout: 'config-share', requiresAuth: true, requiresDevice: true },
  },
  {
    path: '/config-share/mine',
    name: ConfigShareRouteName.mine,
    component: () => import('@/components/config_share/config_share_home.vue'),
    props: { initialScope: 'mine' },
    meta: { layout: 'config-share', requiresAuth: true },
  },
  {
    path: '/config-share/users/:userId',
    name: ConfigShareRouteName.user,
    component: () => import('@/components/config_share/config_share_home.vue'),
    props: (route) => ({ initialScope: 'user', userId: String(route.params.userId || '') }),
    meta: { layout: 'config-share' },
  },
]
